import Vue from 'vue';
import VueRouter from 'vue-router';

import auth from "@/auth/authService";
import Profile from "@/views/Profile";
import Home from '@/components/Home';
import Callback from '@/components/Callback';
import Apps from '@/components/Apps';
import Cluster from '@/components/Cluster';

Vue.use(VueRouter);

const router = new VueRouter({
  mode: 'history',
  routes: [
    { path: '/', component: Home},
    { name: 'home', path: '/', component: Home} ,
    { name: 'callback', path: '/callback', component: Callback },
    { name: 'apps', path: '/apps', component: Apps },
    { name: 'cluster', path: '/cluster/:ClusterName', component: Cluster },
    { name: 'profile', path: '/profile', component: Profile }
  ] 
});

// NEW - add a `beforeEach` handler to each route
router.beforeEach((to, from, next) => {
  if (process.env.NODE_ENV == 'development') { 
    return next();
  }

  if (to.path === "/" || to.path === "/callback" || auth.isAuthenticated()) {
    return next();
  }

  // Specify the current path as the customState parameter, meaning it
  // will be returned to the application after auth
  auth.renewTokens().then(() => { return next(); })
  .catch(() => { auth.login({ target: to.path })});
});

export default router;